import { render, staticRenderFns } from "./IconPageNext.vue?vue&type=template&id=649edbc2&"
import script from "./IconPageNext.vue?vue&type=script&lang=js&"
export * from "./IconPageNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports